@layer module {
.trigger {
            display: inline-flex;
            flex-shrink: 0;
            align-items: center;
            padding: 0;
            border: 0;
            cursor: pointer;
    }

.tooltip-content {
            display: flex;
            flex-direction: column;
    }
} // layer module










@layer app {
.tooltip-content {
            gap: $size-8;
            max-width: $size-230;
    }

.tooltip-title {
            margin-bottom: $size-2;
    }

.trigger {
            background: none;
    }

.trigger--outline {
            color: inherit;
    }
} // layer app
